import "core-js/modules/es.array.map.js";
import { modelizeProduct, contextualizeFund } from '../models';
export var comparisonsLayers = [{
  id: 'SuperComparison',
  type: 'compareProducts',
  action: 'compareProducts',
  name: 'comparison',
  sendEvent: true,
  event: true,
  contextualize: function contextualize(_ref) {
    var id = _ref.id,
      funds = _ref.funds;
    return {
      id: id,
      compareProducts: {
        products: funds.map(contextualizeFund)
      }
    };
  }
}, {
  id: 'FundsComparison',
  type: 'compareProducts',
  action: 'compareProducts',
  name: 'comparison',
  sendEvent: true,
  event: true,
  contextualize: function contextualize(_ref2) {
    var id = _ref2.id,
      funds = _ref2.funds;
    return {
      id: id,
      compareProducts: {
        products: funds.map(contextualizeFund)
      }
    };
  }
}, {
  id: 'ComparisonDrawer',
  type: 'addProductToComparison',
  action: 'addProductToComparison',
  name: 'comparison',
  model: 'product',
  modelize: function modelize(_ref3) {
    var products = _ref3.products;
    return products.map(function (item) {
      return modelizeProduct(item);
    });
  },
  event: true
}, {
  id: 'ComparisonDrawer',
  type: 'restoreProductComparison',
  action: 'restoreProductComparison',
  name: 'comparison',
  model: 'product',
  modelize: function modelize() {
    return [];
  },
  event: true
}, {
  id: 'ComparisonDrawer',
  type: 'compareProducts',
  action: 'compareProducts',
  name: 'comparison',
  model: 'product',
  modelize: function modelize(_ref4) {
    var products = _ref4.products;
    return products.map(function (item) {
      return modelizeProduct(item);
    });
  },
  event: true,
  sendEvent: true
}];